
import api from "@/api/index";
import { Component, Vue } from "vue-property-decorator";
import {
  CardDetailReportItemDto,
  CardDetailReportOfBuyDto, OrganizationUnitDto
} from "@/api/appService";
import { DefaultElementTable } from "@/lib/ElementTableView";
import { Dictionary } from "vue-router/types/router";
import ExportTableHtml from "@/components/ExportTableHtml/index.vue";

@Component({ name: "CardDetailReport",
  components: {ExportTableHtml}
})
export default class CardDetailReport extends Vue {
  queryForm: any = {
    year: new Date().getFullYear(),
    orgId: undefined
  };

  queryFormDataSource: any = {
    years: [],
    stores: []
  };

  private hasTry:boolean = false;

  public table = DefaultElementTable;
  private showStoreChoose:boolean = false;
  private loading:boolean = true;

  get skipCount() {
    return (this.table.page - 1) * this.table.pagesize;
  }

  monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  reportResult: CardDetailReportItemDto[] = [];
  reportResultFull:CardDetailReportItemDto[] = [];

  async created() {
    const now = new Date();
    for (let i = 2020; i <= now.getFullYear(); i++) {
      this.queryFormDataSource.years.push(i);
    }

    const ou = this.$store.getters['user/ou'] as OrganizationUnitDto;
    if(ou && ou.level === '门店'){
      this.queryForm.orgId = ou.id;
      this.showStoreChoose = false;
    } else {
      this.showStoreChoose = true;
    }

    if(this.showStoreChoose){
      await this.loadStores();
    }
    await this.fetchData();


  }

  async loadStores(){
    await api.organizationUnit.getStoresBySession().then(res=>{
      this.queryFormDataSource.stores = res;
    });
  }

  async fetchData() {
    if(!this.queryForm.orgId || this.queryForm.orgId<=0){
      this.loading = false;
      return;

    }
    const parameter = Object.assign({},{
      skipCount: this.skipCount,
      maxResultCount: this.table.pagesize,
      organizationId:this.queryForm.orgId
    },this.queryForm);

    this.loading = true;
    await api.cardReportDetail
      .getAll(parameter)
      .then(res => {
        this.loading = false;
        this.reportResult = res.items!;
        this.table.totalCount = res.totalCount!
      });
  }

  async fetchAllData(){
    return new Promise((resolve,reject)=>{
      api.cardReportDetail.getAll(Object.assign({},{skipCount:0,maxResultCount:1000000},this.queryForm))
      .then(res=>{
        this.reportResultFull = res.items!;
        setTimeout(()=>{
          resolve();
        },100);
      })
    })
  }

  tryRefresh(){
    this.hasTry = true;
    this.$message.info('系统正在重新统计数据，得花费一点儿时间，待会再来看看吧！');

    const parameter = Object.assign({},{
      skipCount: this.skipCount,
      maxResultCount: this.table.pagesize,
      organizationId:this.queryForm.orgId
    },this.queryForm);
    api.cardReportDetail.resetData({body:parameter}).then(res=>{

    })
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  generateTableBodyDom(reportResult: CardDetailReportItemDto[]){
    let html = "";
    for (let userIndex = 0; userIndex < reportResult.length; userIndex++) {
      let dtoOfUser = reportResult[userIndex];
      for (let orgIndex = 0; orgIndex < dtoOfUser.details!.length; orgIndex++) {
        let dtoOfUserOrg = dtoOfUser.details![orgIndex];
        if(!(dtoOfUserOrg.skuList!.length)){
          continue;
        }
        for (
          let skuIndex = 0;
          skuIndex < dtoOfUserOrg.skuList!.length;
          skuIndex++
        ) {
          let sku = dtoOfUserOrg.skuList![skuIndex];

          for (let i = 0; i < 3; i++) {
            html += "<tr>";
            if (i === 0 && skuIndex === 0 && orgIndex === 0) {
              // show user name
              let userRowSpan =
                dtoOfUser.details!.length * dtoOfUserOrg.skuList!.length * 3;
              html += `<td rowspan="${userRowSpan}">${dtoOfUser.userName}</td>`;
            }

            if (i === 0 && skuIndex === 0) {
              html += `<td rowspan="${dtoOfUserOrg.skuList!.length * 3}">${
                dtoOfUserOrg.orgName
              }</td>`;
            }

            if (i === 0) {
              html += `<td rowspan="3">${sku.cardFullName}</td>`;
            }
            if (i === 0) {
              html += "<td>购买</td>";
              for (let month = 1; month <= 12; month++) {
                let value = (sku.buyDetails as Dictionary<
                  CardDetailReportOfBuyDto
                  >)[month];
                html += `<td>${value ? value.buy : ""}</td>`;
              }
            } else if (i === 1) {
              html += "<td>新购/续费</td>";
              for (let month = 1; month <= 12; month++) {
                let value = (sku.buyDetails as Dictionary<
                  CardDetailReportOfBuyDto
                  >)[month];
                html += `<td>${value ? value.type : ""}</td>`;
              }
            } else if (i === 2) {
              html += "<td>消费</td>";
              for (let month = 1; month <= 12; month++) {
                html += `<td>${
                  (sku.consumeDetails as Dictionary<number>)[month]
                }</td>`;
              }
            }
            html += "</tr>";
          }
        }
      }
    }
    return html;
  }

  get buildTableBody() {
    return this.generateTableBodyDom(this.reportResult);
  }

  get buildTableBodyOfFull(){
    return this.generateTableBodyDom(this.reportResultFull);
  }

  handleSearch() {
    this.fetchData();
  }
}
